export const CREATE_CLAIMFORM_START = "CREATE_CLAIMFORM_START";
export const CREATE_CLAIMFORM_FAILURE = "CREATE_CLAIMFORM_FAILURE";
export const CREATE_CLAIMFORM_SUCCESS = "CREATE_CLAIMFORM_SUCCESS";
export const CREATE_CLAIMFORM_RESET = "CREATE_CLAIMFORM_RESET";

export const UPDATE_CLAIMFORM_START = "UPDATE_CLAIMFORM_START";
export const UPDATE_CLAIMFORM_FAILURE = "UPDATE_CLAIMFORM_FAILURE";
export const UPDATE_CLAIMFORM_SUCCESS = "UPDATE_CLAIMFORM_SUCCESS";
export const UPDATE_CLAIMFORM_RESET = "UPDATE_CLAIMFORM_RESET";

export const GET_CLAIMFORM_START = "GET_CLAIMFORM_START";
export const GET_CLAIMFORM_FAILURE = "GET_CLAIMFORM_FAILURE";
export const GET_CLAIMFORM_SUCCESS = "GET_CLAIMFORM_SUCCESS";
export const GET_CLAIMFORM_RESET = "GET_CLAIMFORM_RESET";



export const SORT_CLAIMFORM_START = "SORT_CLAIMFORM_START";
export const SORT_CLAIMFORM_FAILURE = "SORT_CLAIMFORM_FAILURE";
export const SORT_CLAIMFORM_SUCCESS = "SORT_CLAIMFORM_SUCCESS";
export const SORT_CLAIMFORM_RESET = "SORT_CLAIMFORM_RESET";


export const VIEW_CLAIMFORM_START = "VIEW_CLAIMFORM_START";
export const VIEW_CLAIMFORM_FAILURE = "VIEW_CLAIMFORM_FAILURE";
export const VIEW_CLAIMFORM_SUCCESS = "VIEW_CLAIMFORM_SUCCESS";
export const VIEW_CLAIMFORM_RESET = "VIEW_CLAIMFORM_RESET";


export const CREATE_CLAIM_LINK = "CREATE_CLAIM_LINK"
export const CREATE_CLAIM_LINK_SUCCESS = "CREATE_CLAIM_LINK_SUCCESS"
export const CREATE_CLAIM_LINK_FAILED = "CREATE_CLAIM_LINK_FAILED"


export const VIEW_CLAIM_LINK = "VIEW_CLAIM_LINK"
export const VIEW_CLAIM_LINK_SUCCESS = "VIEW_CLAIM_LINK_SUCCESS"
export const VIEW_CLAIM_LINK_FAILED = "VIEW_CLAIM_LINK_FAILED"


export const SUBMIT_CLAIM_LINK = "SUBMIT_CLAIM_LINK"
export const SUBMIT_CLAIM_LINK_SUCCESS = "SUBMIT_CLAIM_LINK_SUCCESS"
export const SUBMIT_CLAIM_LINK_FAILED = "SUBMIT_CLAIM_LINK_FAILED"

export const CUSTOMER_POLICY_CLAIM = "CUSTOMER_POLICY_CLAIM"
export const CUSTOMER_POLICY_CLAIM_SUCCESS = "CUSTOMER_POLICY_CLAIM_SUCCESS"
export const CUSTOMER_POLICY_CLAIM_FAILED = "CUSTOMER_POLICY_CLAIM_FAILED"

export const CUSTOMER_POLICY_LOB = "CUSTOMER_POLICY_LOB"
export const CUSTOMER_POLICY_LOB_SUCCESS = "CUSTOMER_POLICY_LOB_SUCCESS"
export const CUSTOMER_POLICY_LOB_FAILED = "CUSTOMER_POLICY_LOB_FAILED"